export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Zadara Cloud",
  list: [
    {
      label: "Fully Managed Services",
      text: "Offers 24/7 proactive monitoring, support, and seamless upgrades, freeing IT teams from ongoing maintenance tasks.",
    },
    {
      label: "Consumption-Based Pricing",
      text: "With a pay-as-you-go model and no long-term contracts, organizations can scale resources up or down based on demand, optimizing costs.",
    },
    {
      label: "Global Edge Cloud Presence",
      text: "Zadara's extensive network of edge cloud locations ensures that compute and storage resources are available closer to end-users, reducing latency and improving performance.",
    },
    {
      label: "Multi-Tenancy with Single-Tenant Experience",
      text: "While supporting multiple tenants on the same physical infrastructure, Zadara ensures predictable performance, data privacy, and security for each tenant.",
    },
    {
      label: "Comprehensive Security",
      text: "The platform incorporates robust security measures, including data isolation, encryption, and compliance with industry standards, safeguarding sensitive information.",
    },
  ],
};
